import React, { useContext, useState } from "react";
import ClassNames from "classnames";
import { useTransition, animated } from "react-spring";
import LocalizedLink from "../LocalizedLink";
import { LocaleConsumer, UserIPLocation } from "../Layout";
import LanguageSwitch from "../LocalizedLink/LanguageSwitch";
import * as s from "./s.module.scss";

// Icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { MenuOpenContext } from "./index";

const SubNav = ({
  data,
  data2,
  title,
  label,
  link,
  icon,
  currentPath,
  languageSwitch,
}) => {
  const { menuOpen, setMenuOpen } = useContext(MenuOpenContext);
  const [subNav2, setSubNav2] = useState(false);

  const handleMenuOpenChange = (force) => {
    let newMenuOpen = {};
    newMenuOpen[title] =
      typeof force === "undefined" ? !menuOpen[title] : force;
    setMenuOpen({ ...menuOpen, ...newMenuOpen });
  };

  const config = { mass: 1, tension: 2000, friction: 100 };

  const transitions = useTransition(menuOpen[title], null, {
    config,
    from: { opacity: 0, transform: "scale(0.96)" },
    enter: { opacity: 1, transform: "scale(1)" },
    leave: { opacity: 0, transform: "scale(0.96)" },
  });
  const { userIPLocationCode } = useContext(UserIPLocation);
  return (
    <LocaleConsumer>
      {() => {
        return (
          <div onMouseLeave={() => handleMenuOpenChange(false)}>
            <button
              className={ClassNames(s.dropdownBtn)}
              onMouseEnter={() => handleMenuOpenChange(true)}
              aria-label={"global"}
            >
              <LocalizedLink to={link}>
                {title && (
                  <span
                    className={
                      (currentPath &&
                        currentPath.includes(
                          label.toLowerCase().replace(/\s/g, "-")
                        ) &&
                        s.currentPath) ||
                      ""
                    }
                  >
                    {title}
                  </span>
                )}
              </LocalizedLink>
              {icon && <div className={s.icon}>{icon}</div>}
              <FontAwesomeIcon icon={faChevronDown} />
            </button>
            {transitions.map(({ item, key, props }) => {
              return (
                item && (
                  <animated.div
                    style={{
                      ...props,
                      position: "absolute",
                      top: "100%",
                      left: 0,
                    }}
                    className={s.dropdownMenuItemContainer}
                    key={key}
                    onMouseLeave={() => handleMenuOpenChange(false)}
                  >
                    {languageSwitch &&
                      data.map((list, i) => (
                        <LanguageSwitch
                          ipCode={userIPLocationCode}
                          key={i}
                          to={list.link}
                          type={list.type}
                          onClick={() => handleMenuOpenChange(false)}
                          className={s.dropdownMenuItem}
                        >
                          <span>{list.title}</span>
                        </LanguageSwitch>
                      ))}
                    {!languageSwitch &&
                      data.map((list, i) => {
                        if (list.subNav2) {
                          return (
                            <LocalizedLink
                              key={i}
                              to={list.link}
                              type={list.type}
                              className={s.dropdownMenuItem}
                              onMouseEnter={() => setSubNav2(true)}
                              onMouseLeave={() => setSubNav2(false)}
                            >
                              <div
                                className={ClassNames(
                                  s.subNav2,
                                  currentPath &&
                                    currentPath.includes(
                                      list.label
                                        .toLowerCase()
                                        .replace(/\s/g, "-")
                                    ) &&
                                    s.currentPath
                                )}
                              >
                                {list.title}
                                {subNav2 && (
                                  <div
                                    className={s.subNav2ContMenu}
                                    onMouseEnter={() => setSubNav2(true)}
                                  >
                                    {data2.map((x, i) => {
                                      return (
                                        <LocalizedLink
                                          key={i}
                                          to={x.link}
                                          type={x.type}
                                          onClick={() =>
                                            handleMenuOpenChange(false)
                                          }
                                          className={s.dropdownMenuItem}
                                        >
                                          <span>{x.title}</span>
                                        </LocalizedLink>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            </LocalizedLink>
                          );
                        } else {
                          return (
                            <LocalizedLink
                              key={i}
                              to={list.link}
                              type={list.type}
                              onClick={() => handleMenuOpenChange(false)}
                              className={s.dropdownMenuItem}
                            >
                              <span
                                className={
                                  currentPath &&
                                  currentPath.includes(
                                    list.label.toLowerCase().replace(/\s/g, "-")
                                  ) &&
                                  s.currentPath
                                }
                              >
                                {list.title}
                              </span>
                            </LocalizedLink>
                          );
                        }
                      })}
                  </animated.div>
                )
              );
            })}
          </div>
        );
      }}
    </LocaleConsumer>
  );
};

export default SubNav;
